import { Link } from "react-router-dom";
import { CopyField } from "../components/CopyField.tsx";
import { PageHeader } from "../components/States.tsx";

export default function GettingStarted() {
  return (
    <section className="getting-started">
      <PageHeader
        title="Get started"
        subtitle="Install the CLI, authenticate this org, and start syncing."
      />

      <ol className="steps">
        <li className="step card">
          <div className="step-num">1</div>
          <div className="step-body">
            <h3>Install the CLI</h3>
            <p>
              Stift is open source. Install it with the one-liner (or grab a
              release binary):
            </p>
            <CopyField
              value="curl https://stift.sh/install.sh | sh"
              prompt="$"
              multiline
            />
          </div>
        </li>

        <li className="step card">
          <div className="step-num">2</div>
          <div className="step-body">
            <h3>Create a token</h3>
            <p>
              Head to the{" "}
              <Link to="/tokens" className="link">
                Tokens
              </Link>{" "}
              page and create an API token for this organization. Copy it — the
              secret is shown only once.
            </p>
          </div>
        </li>

        <li className="step card">
          <div className="step-num">3</div>
          <div className="step-body">
            <h3>Log in</h3>
            <p>Point the CLI at Stift Cloud with your token:</p>
            <CopyField
              value="stift login https://sync.stift.sh --token <token>"
              prompt="$"
              multiline
            />
          </div>
        </li>

        <li className="step card">
          <div className="step-num">4</div>
          <div className="step-body">
            <h3>Push & pull</h3>
            <p>
              Sync your coding-agent sessions. They&apos;ll appear on the{" "}
              <Link to="/sessions" className="link">
                Sessions
              </Link>{" "}
              page.
            </p>
            <CopyField value="stift push" prompt="$" multiline />
            <CopyField value="stift pull" prompt="$" multiline />
          </div>
        </li>
      </ol>
    </section>
  );
}
